
export interface SearchState {
  searchString: string;
  searchQueryLoading: boolean;
  searchFilteredRecipes: Array<SearchHit>;
  searchFilters: SearchFiltersInterface;
  ingredientsNameList: Array<string>;
  cuisineNameList: Array<string>;
  mealTypeList: Array<string>;
  searchPageFilteredRecipes: Array<SearchFilteredRecipesInterface>
  searchFilteredIngredients: Array<SearchIngredients>
  sortMode: string
  defaultExplorePageSearchList: Array<SearchHit>
  // ingredientQueryLoading:boolean
}

export interface SearchFilteredRecipesInterface {
  id: string,
  metadata: {
    name: string,
    cookTime: number,
    url: string,
    prepTime: number,
    active: boolean,
    tags: Array<string>,
    maxServing: number,
    minServing: number,
    categories: Array<string>,
    author: string,
    createdSource: string,
    createdBy: string,
    hiddenTags: Array<string>,
    ingredients: Array<string>,
    ingredientsListIds: Array<string>,
    mealType: Array<string>,
    cuisine: Array<string>,
    recipeMarketPrice: number,
    rating:number|null,
    ratingCount:number|null,
    lastEditedAt:string,
    updatedAt:string
    
  },
  allergens: Array<string>
}

export interface RatingsInterface {
  recipeID: string,
  rating: number,
  ratingCount : number

}

export interface SearchFiltersInterface {
  cuisineFilter: Array<string>;
  ingredientFilter: Array<string>;
  courseFilter: string;
  timeFilter: string;
  servingSizeFilter: Array<string>;
  mealTypeFilter: Array<string>;
}

export interface SearchHit {
  id: string,
  metadata: {
    name: string,
    url: string,
  }
}

export interface SearchIngredients {
  id: string,
  metadata: {
    name: string,
    url: string,
    defaultWeightUnit: string,
    secondaryUnit: string,
    created_by: string,
    created_source: string
  }
}

export interface SearchHitForDuplicatingRecipes {
  id: string,
  metadata: {
    name: string,
    image_url: string,
    is_public: boolean,
    created_source: string,
    created_by: string | null
  }
}

export enum UserDietTypes {
  VEGAN = 'vegan',
  VEG = 'veg',
  EGG = 'egg',
  NONVEG = 'nonVeg'
}

export enum RecipeDietTypes {
  VEGAN = 'Vegan',
  VEG = 'Veg',
  EGG = 'Egg',
  NONVEG = 'Non-Veg'
}
